export default __webpack_public_path__ + "static/media/customer_floating.e8873059.png";